import ListenerMap from './ListenerMap'
import events from './events'

const EventTarget = function () {
  this.listenerMap = new ListenerMap(this)
  this.unlisteners_ = []
}

/**
 * @param {EventLike } e
 */
EventTarget.prototype.dispatchEvent = function (e) {
  var type, event
  if (typeof e == 'string') {
    type = e
    event = { type }
  } else {
    type = e.type
    event = e
  }
  this.fireListeners(type, undefined, event)
}

EventTarget.prototype.fireListeners = function (type, capture, event) {
  if (!this.listenerMap || !this.listenerMap.listeners){
    console.warn('Firing an event on a destroyed instance. Doing nothing...')
    return
  }
  var listenerArray = this.listenerMap.listeners[String(type)]
  if (listenerArray) {
    // Clone the array encase firing the listeners removes or adds new ones
    listenerArray = listenerArray.slice(0)
  } else {
    listenerArray = []
  }
  for (var i = 0; i < listenerArray.length; i++) {
    var listener = listenerArray[i]
    const listenerFn = listener.listener
    const listenerHandler = listener.handler || listener.src
    listenerFn.call(listenerHandler, event)
  }
}

EventTarget.prototype.destroy = function () {
  this.dispatchEvent({
    type: 'destroy',
    target: this,
  })
  this.listenerMap.destroy()

  while (this.unlisteners_.length){
    var unlistener = this.unlisteners_.pop()
    unlistener()
  }
  delete this.unlisteners_
}

EventTarget.prototype.log_ = function () {
  console.log(...arguments)
}

EventTarget.prototype.addEventListener = function (
  type,
  listener,
  opt_options,
  opt_handler
) {
  return events.listen(this, type, listener, opt_options, opt_handler)
}

EventTarget.prototype.removeEventListener = function (
  type,
  listener,
  opt_options,
  opt_handler
) {
  return events.unlisten(this, type, listener, opt_options, opt_handler)
}

/**
 * This is the same as `events.listen` however it will automatically tear down
 * these event listeners when this instance is destroyed.
 */
EventTarget.prototype.listen = function(target, event, listener, opt_options, opt_handler){
  var unlistener = events.listen(target, event, listener, opt_options, opt_handler)
  this.unlisteners_.push(unlistener)
}

export default EventTarget
